<template>
  <div class="main">
      <div class="banner">
        <img src="@/assets/images/banner.png" />
      </div>
      <div class="login">
          <div class="login_head">
              <img src="@/assets/images/logo.png" />
          </div>
          <div class="login_body" v-loading="loading">
              <h1>找回密码</h1>
              <el-form v-if="step==1" :model="getpw" status-icon ref="getpw" label-width="0">                  
                  <el-form-item prop="mobile" ref="mobile" :rules="{ required: true, validator: validatePhone, trigger: 'blur' }">
                      <el-input type="text" v-model="getpw.mobile" placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="token" :rules="{ required: true, message: '请输入验证', trigger: 'blur' }">
                      <validate @success="SetToken"></validate>
                    </el-form-item>
                  <el-form-item prop="code" v-if="getpw.token" :rules="{ required: true, message: '必填', trigger: 'blur' }">
                      <el-input type="password" v-model="getpw.code" placeholder="短信验证码">
                        <el-button slot="append" @click="(wait==60)?sendSms():'javascript:void(0)'">{{smsMsg}}</el-button>
                      </el-input>
                    </el-form-item>
                  <el-form-item>
                    <el-button type="primary" style="width:100%;padding:.8em 0;font-size: 1.2em;;" size="large" @click="submitForm('getpw')">下一步</el-button>
                  </el-form-item>
              </el-form>
              <el-form v-if="step==2" :model="pswForm" status-icon ref="pswForm" label-width="0">                  
                <el-form-item prop="passwdNew" :rules="{ required: true, validator: validatePsw, trigger: 'blur' }">
                  <el-input type="password" v-model="pswForm.passwdNew" placeholder="输入新密码，由数字、字母（8-16位）组成"></el-input>
                </el-form-item>
                <el-form-item prop="passwdNew2" :rules="{ required: true, validator: validatePsw2, trigger: 'blur' }">
                  <el-input type="password" v-model="pswForm.passwdNew2" placeholder="再次输入一遍新密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width:100%;padding:.8em 0;font-size: 1.2em;;" size="large" @click="submitForm('pswForm')">确 定</el-button>
                </el-form-item>
              </el-form>
              <p class="align-center">
                  <router-link to="/">登录</router-link> |
                  <router-link to="/register">注册</router-link>
              </p>
          </div>
      </div>
      <!-- <p></p> -->
  </div>
</template>

<script>
import * as API from '@/api/main'
import Validate from "@/components/Nc.vue";
export default {
name: '',
components: {
  Validate,
},
data() {
  return {
    step:1,
    getpw:{
      mobile:"",
      code:"",
      passwd:"",
      token: ""
    },
    pswForm:{
      passwdNew:"",
      passwdNew2:"",
    },
    smsMsg:"发送验证码",
    wait:60,//验证码重置发送时间
    loading:false,
  }
},
methods: {
  
  //提交
  submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.step==1){
            this.getpw.flag=1;
            API.Register(this.getpw).then(res=>{
              this.$message({
                message: res.info,
                type: 'success'
              });
              this.step=2;     
            })
          }else{
            this.pswForm.flag=1;
            this.pswForm.mobile=this.getpw.mobile;
            API.UpdatePassword(this.pswForm).then(res=>{
              this.$message({
                message: res.info,
                type: 'success'
              });           
              // localStorage.setItem('user',JSON.stringify(res.data));
              this.$router.push({path:'/'});
            })
          }          
        } else {
          return false;
        }
      });
  },

  //重置校验
  resetForm(formName) {
      this.$refs[formName].resetFields();
  },

  SetToken(resp) {
    this.getpw.token = resp;
  },

  //发送手机验证码验证
  sendSms(){
    let phoneReg1 = /^1[3456789]\d{9}$/;
    let number=this.getpw.mobile;
    if(!phoneReg1.test(number)){
      this.$refs.getpw.validateField('mobile');
    }else{
      this.checkVerify();
    }
  },

  //校验手机号码
  validatePhone(rule, value, callback) {
    let phoneReg1 = /^1[3456789]\d{9}$/; //大陆手机号验证
    if (!value) {
      return callback(new Error('请输入手机号码')) ;
    }
    setTimeout(() => {
      if (!phoneReg1.test(value)) {
        callback(new Error('手机号码格式有误'));
      } else {
        callback();
      }
    }, 0)
  },

  //校验密码
  validatePsw(rule, value, callback) {
    let pswReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/; //有数字、密码，8-16位
    if (!value) {
      return callback(new Error('请输入密码')) ;
    }
    setTimeout(() => {
      if (!pswReg.test(value) && value.indexOf("*")==-1) {
        callback(new Error('由数字、字母（8-16位）组成'));
      } else {
        callback();
      }
    }, 0)
  },

  //发送验证码
  checkVerify(){
    this.loading=true;
    var postdata={
      mobile:this.getpw.mobile,
      token:this.getpw.token
    }      
    API.SmsCode(postdata).then(res=>{
      this.$message({
        message: '短信验证码已发送，请及时查收',
        type: 'success'
      });
      this.loading=false;
      this.time();//60秒倒计时
    })
  },

  //倒计时
  time() {
    // console.log(this.wait)
    if (this.wait == 0) {          
      this.smsMsg="重新获取";
      this.wait = 60;
    } else {
      this.smsMsg=this.wait+"s";
      this.wait--;
      setTimeout(() => {
        this.time()
      }, 1000);
    }
  },

  //校验密码
  validatePsw(rule, value, callback) {
      let pswReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/; //有数字、密码，8-16位
      if (!value) {
        return callback(new Error('请输入密码')) ;
      }
      setTimeout(() => {
        if (!pswReg.test(value) && value.indexOf("*")==-1) {
          callback(new Error('由数字、字母（8-16位）组成'));
        } else {
          callback();
        }
      }, 0)
    },
    
    //重复
    validatePsw2(rule, value, callback) {
      // let pswReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/; //有数字、密码，8-16位
      if (!value) {
        return callback(new Error('请再次输入密码')) ;
      }
      setTimeout(() => {
        if (value===this.pswForm.passwdNew) {
          callback();
        } else {          
          callback(new Error('两次密码输入不一致'));
        }
      }, 0)
    },

},
created() {
  localStorage.removeItem('auth');
},
}
</script>

<style scoped>
  /* .main{} */
  .banner{background:#D6000F;width: 100%;height:100px;text-align: center;}
  .login{width:480px;position: relative;border-radius: 10px;margin:50px auto 0;padding-bottom:4em;}
  .login::after{content:"@经观传媒 版权所有";position: absolute;text-align: center;width:100%;margin-top:10px;}
  .login_head{width:100%;text-align: center;padding:2em 0;border-radius: 10px 10px 0 0;}
  .login_head img{width:40%;}
  .login_body{width:100%;padding:2em 5em;box-sizing: border-box;background:#fff;box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);border:1px solid rgba(0, 40, 100, 0.12);border-top:4px solid var(--mainColor);}
  .login_body h1{text-align: left;font-size:1.2em;padding:1em 0;}
  p{width:100%;}
  .avatar-uploader-icon{font-size: 28px; color: #8c939d; width: 100px;height: 100px; line-height: 100px;text-align: center;}
  
  .el-image{height:100px;width:100px;border-radius: 50%;}
  .el-image img{height:100%;}
  @media screen and (max-width: 480px){
      .banner{display:none;}
      .login{width: 100%;margin:0;}
      .login_body{padding:2em 5%;margin:auto;}
  }
</style>
